<template>
  <p class="text-red-500"><slot /></p>
</template>

<script>
export default {};
</script>